import styled, { css } from "styled-components/macro";
import {
  darkModeBackgroundColor,
  darkModeCardBackgroundColor,
  darkModeTextColor,
  lightGrey,
} from "../../constants/colors";
import {
  FONT_SIZE_SMALL,
  EXPAND_ICON_TRANSITION,
} from "../../constants/constants";

export const ReportListStyles = styled.div<{
  $isDarkMode?: boolean;
  $isInsideExpand?: boolean;
}>`
  padding-left: ${props => (props.$isInsideExpand ? 2 : 0)}em;

  .shiftItem {
    padding-left: 4em;
    ${({ $isDarkMode }) =>
      $isDarkMode
        ? css`
            background-color: ${darkModeBackgroundColor};
          `
        : ""}
  }

  .MuiListItemIcon-root {
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
  }

  .shiftBtnLabel {
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeBackgroundColor : lightGrey};
  }

  /* remove <a> underline and blue color */
  a {
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
    text-decoration: none;
  }
  @media (max-width: 550px) {
    [class*="ReportItemAccordion__ReportsFiltersStyles"] {
      gap: 8px;
    }
    .searchInput {
      display: none;
    }
    .groupInput {
      width: 160px;
    }
    .datePickerCalendar {
      transform: translate(-51%);
    }
  }
`;

export const ReportButtonStyles = styled.div<{ $isDarkMode: boolean }>`
  &.shiftReports {
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeCardBackgroundColor : lightGrey};

    .btnLabel {
      span {
        font-size: ${FONT_SIZE_SMALL}px;
      }
    }
  }

  button svg {
    transition: ${EXPAND_ICON_TRANSITION};
  }
  .btnLabel {
    margin-left: 0.5em;
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
  }
  display: flex;
  .btnCollapse {
    height: 59px;
    padding: 12px;
    width: 100%;
    text-align: left;
    &:hover {
      background: none;
      .MuiTouchRipple-root {
        background: rgba(0, 0, 0, 0.08);
      }
    }
  }
  .MuiTouchRipple-root {
    margin: 6px;
    width: 48px;
    height: 48px;
  }
`;
